import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Avatar } from 'primereact/avatar';
import { Tag } from 'primereact/tag';
import { Tooltip } from '@mui/material'; // Mantén Tooltip si lo necesitas para la imagen de la unidad

// Iconos de react-icons/fa relevantes para la unidad
import {
    FaTruck, FaCar, FaTag, FaRoad, FaCalendarAlt, FaRulerCombined, FaWeight,
    FaGasPump, FaMapMarkerAlt, FaImage, FaUser, FaCheckCircle, FaTimesCircle,
    FaInfoCircle, FaCarSide, FaPalette, FaTools, FaBuilding,
    FaIdCard
} from 'react-icons/fa';

import './UnitDetailModal.scss'; // SCSS específico para el modal de unidad (lo crearemos en el paso 2)
import { getInformacionUnidad } from '../MaestroDeServiciosIntegracion';

// *** NECESITAS CREAR ESTE SERVICIO EN TU BACKEND Y FRONTEND ***
// Puedes usar el mismo patrón que getInfoOperador.
// Esta es una simulación.
const getInfoUnidad = async (setUnitDetails, idUnit, setLoading) => {
    setLoading(true);
    try {
        // Simula una llamada a la API
        getInformacionUnidad(setUnitDetails,idUnit,setLoading)
    } catch (error) {
        console.error("Error fetching unit details:", error);
        setUnitDetails(null); // Limpia los detalles en caso de error
    } finally {
        setLoading(false);
    }
};


const UnitDetailModal = ({ idUnit, visible, onHide }) => {
    const [unitDetails, setUnitDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && idUnit) {
            getInfoUnidad(setUnitDetails, idUnit, setLoading);
        } else if (!visible) {
            setUnitDetails(null); // Limpiar datos cuando el modal se oculta
        }
    }, [visible, idUnit]); // Asegúrate de que idUnit sea una dependencia

    const header = (
        <div className="unit-modal-header">
            {/* Avatar para la imagen de la unidad */}
            <Tooltip title={<img src={unitDetails?.FOTOGRAFIA} alt="Unidad" style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }} />}>
                <div>
                    {/* Si no hay FOTOGRAFIA_URL, usa un icono de camión */}
                    <Avatar image={unitDetails?.FOTOGRAFIA} icon="pi pi-truck" shape="circle" className="unit-avatar" />
                </div>
            </Tooltip>
            <div className="unit-header-info">
                <h2 className="unit-name">{unitDetails?.DESCRIPCION || 'Cargando...'}</h2>
                <span className="unit-id">ID: {idUnit || '-'}</span>
                {unitDetails?.DESCRIPCION && <span className="unit-description">{unitDetails.DESCRIPCION}</span>}
            </div>
            {unitDetails && (
                <div className="unit-status">
                    {/* Asumiendo que 'ACTIVA' es un booleano en los datos de la unidad */}
                    {unitDetails.ACTIVA ? (
                        <Tag value="Activa" severity="success" icon="pi pi-check-circle" />
                    ) : (
                        <Tag value="Inactiva" severity="danger" icon="pi pi-times-circle" />
                    )}
                </div>
            )}
        </div>
    );

    // Reutilizamos la función renderDetailCard, adaptada para los datos de unidad
    const renderDetailCard = (title, icon, fields) => (
        <div className="detail-card">
            <div className="detail-card-header">
                {React.cloneElement(icon, { className: "detail-card-icon" })}
                <h3>{title}</h3>
            </div>
            <div className="detail-card-content">
                {fields.map((field, index) => (
                    <div className="detail-item" key={index}>
                        {field.icon && React.cloneElement(field.icon, { className: "detail-item-icon" })}
                        <span><strong>{field.label}:</strong> {field.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <Dialog
            header={header}
            visible={visible}
            style={{ width: '65vw' }}
            breakpoints={{ '1200px': '75vw', '960px': '90vw', '641px': '100vw' }}
            onHide={onHide}
            modal
            draggable={false}
            resizable={false}
            closeOnEscape
            className='UnitDetailModal' // Clase específica para el modal de unidad
        >
            {loading ? (
                <div className="modal-loading-container">
                    <ProgressSpinner />
                    <p className="loading-text">Cargando detalles de la unidad...</p>
                </div>
            ) : unitDetails ? (
                <div className="unit-details-content">
                    <div className="unit-details-grid">
                        {renderDetailCard("Identificación y Estatus de la Unidad", <FaTruck />, [
                            // { label: "No. Económico", value: unitDetails.NO_ECONOMICO || '-', icon: <FaTag /> },
                            { label: "Descripción", value: unitDetails.DESCRIPCION || '-', icon: <FaInfoCircle /> },
                            { label: "Estatus", value: unitDetails.ESTATUS || '-', icon: <FaInfoCircle /> },
                            {
                                label: "Activa",
                                value: unitDetails.ACTIVA ? <span className="status-active">Sí</span> : <span className="status-inactive">No</span>,
                                icon: unitDetails.ACTIVA ? <FaCheckCircle className="status-active" /> : <FaTimesCircle className="status-inactive" />
                            }
                        ])}
                        {renderDetailCard("Fechas y Registro", <FaCalendarAlt />, [
                            { label: "Fecha Alta", value: unitDetails.FECHA_ALTA || '-', icon: <FaCalendarAlt /> },
                            { label: "Fecha Baja", value: unitDetails.FECHA_BAJA || 'N/A', icon: <FaCalendarAlt /> },
                            // { label: "Kardex Mantenimiento", value: unitDetails.KARDEX_MANTENIMIENTO || '-', icon: <FaTools /> }
                        ])}
                        {renderDetailCard("Especificaciones del Vehículo", <FaCarSide />, [
                            { label: "Tipo", value: unitDetails.TIPO || '-', icon: <FaCarSide /> },
                            { label: "Marca", value: unitDetails.MARCA || '-', icon: <FaBuilding /> },
                            { label: "Modelo", value: unitDetails.MODELO || '-', icon: <FaCalendarAlt /> },
                            { label: "Serie", value: unitDetails.NUMERO_SERIE || '-', icon: <FaIdCard /> },
                            { label: "Motor", value: unitDetails.NUMERO_MOTOR || '-', icon: <FaTools /> },
                            // { label: "Color", value: unitDetails.COLOR || '-', icon: <FaPalette /> },
                            { label: "Pasajeros", value: unitDetails.PASAJEROS || '-', icon: <FaUser /> }
                        ])}
                        {renderDetailCard("Placas y Rendimiento", <FaTag />, [
                            { label: "Placas Fed.", value: unitDetails.PLACAS_FEDERALES || '-', icon: <FaTag /> },
                            { label: "Placas", value: unitDetails.PLACAS || '-', icon: <FaTag /> },
                            { label: "Rendimiento (KM/L)", value: unitDetails.RENDIMIENTO || '-', icon: <FaGasPump /> }
                        ])}
                        {renderDetailCard("Rastreo y Asignación", <FaMapMarkerAlt />, [
                            { label: "GPS", value: unitDetails.GPS || '-', icon: <FaMapMarkerAlt /> },
                            { label: "ID_WIALON", value: unitDetails.ITEM_ID_WIALON || '-', icon: <FaMapMarkerAlt /> },
                            // { label: "Localizador", value: unitDetails.URL_LOCALIZADOR ? <a href={unitDetails.URL_LOCALIZADOR} target="_blank" rel="noopener noreferrer" className="map-link">Ver en Mapa</a> : 'No disponible', icon: <FaMapMarkerAlt /> },
                            // { label: "Chofer Asignado", value: unitDetails.CHOFER_ASIGNADO || '-', icon: <FaUser /> }
                        ])}
                        {/* {renderDetailCard("Identificación y Estatus de la Unidad", <FaTruck />, [
                            { label: "No. Económico", value: unitDetails.NO_ECONOMICO || '-', icon: <FaTag /> },
                            { label: "Descripción", value: unitDetails.DESCRIPCION || '-', icon: <FaInfoCircle /> },
                            { label: "Estatus", value: unitDetails.ESTATUS || '-', icon: <FaInfoCircle /> },
                            {
                                label: "Activa",
                                value: unitDetails.ACTIVA ? <span className="status-active">Sí</span> : <span className="status-inactive">No</span>,
                                icon: unitDetails.ACTIVA ? <FaCheckCircle className="status-active" /> : <FaTimesCircle className="status-inactive" />
                            }
                        ])} */}
                        {/* {renderDetailCard("Clientes y Complementos", <FaBuilding />, [
                            { label: "Cliente Fija", value: unitDetails.CLIENTE_FIJA || '-', icon: <FaBuilding /> },
                            { label: "Cliente Combina", value: unitDetails.CLIENTE_COMBINA || '-', icon: <FaBuilding /> },
                            { label: "Fotografía", value: unitDetails.FOTOGRAFIA_URL ? <a href={unitDetails.FOTOGRAFIA_URL} target="_blank" rel="noopener noreferrer">Ver Imagen</a> : 'No disponible', icon: <FaImage /> }
                        ])} */}
                 
                    </div>
                </div>
            ) : (
                <div className="modal-no-data-container">
                    <p>No se encontraron detalles para esta unidad.</p>
                </div>
            )}
        </Dialog>
    );
};

export default UnitDetailModal;